import React from 'react';
import { ICONS } from '../common/icons/icons';
import { Link } from 'react-router-dom';
import Animated from './AnimatedComponent';

export interface PageHeaderProps {
  title?: string;
  backBtnLabel?: string;
  backBtnUrl?: any;
  rightContent?: any;
  titleClassName?: string;
}

const PageHeader = ({ title, backBtnLabel, backBtnUrl, rightContent, titleClassName }: PageHeaderProps) => {
  return (
    <div className='h-full w-full flex items-center justify-center relative'>
      <Animated.Screen className='absolute text-primary left-2'>
        {backBtnLabel && (
          <Link to={backBtnUrl} className=' flex items-center justify-center'>
            <span className='text-xl w-6 h-6 text-secondary-foreground bg-secondary-foreground/20 flex items-center justify-center mr-1 rounded-full'>
              {ICONS.chevronLeft}
            </span>
            <span className='text-md text-secondary-foreground'>{backBtnLabel}</span>
          </Link>
        )}
      </Animated.Screen>

      <Animated.Component>
        <h3 className={`font-bold text-black dark:text-white ${titleClassName}`}>{title}</h3>
      </Animated.Component>

      <div className='absolute right-4'>{rightContent}</div>
    </div>
  );
};

export default PageHeader;
